export const getLatestVersion = (data = []) => {
  const versions = data.filter(
    (version) => version.namespace === 'version_published'
  );
  return versions[0];
};
